import Container from "@components/ui-old/container";
import Layout from "@components/layout/layout";
import Accordion from "@components/common/accordion";
import PageHeader from "@components/ui-old/page-header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";
import React from "react";
import { useTranslation } from 'next-i18next';
import { useFaqsQuery } from "@framework/content/get-faq";
import FAQLoader from '@components/ui-old/loaders/faq-loader';
import { AnimatedNoContent } from "@components/other/no-content";
export default function FAQ() {
  const {
    t
  } = useTranslation('faq');
  const {
    data,
    isLoading,
    error
  } = useFaqsQuery();
  if (isLoading) {
    return <FAQLoader />;
  }
  if (error || !data || data.length === 0) {
    return <>
      <PageHeader pageHeader={t("text-page-faq")} />
      <Container>
      <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4">
        <AnimatedNoContent />
      </div>
      </Container>
      </>;
  }
  const faqItems = data?.map(faq => ({
    id: faq.id,
    title: faq.question,
    content: faq.answer
  })) || [];
  return <>
      <PageHeader pageHeader={t("text-page-faq")} data-sentry-element="PageHeader" data-sentry-source-file="faq.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="faq.tsx">
        <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4">
          <Accordion items={faqItems} translatorNS="faq" data-sentry-element="Accordion" data-sentry-source-file="faq.tsx" />
        </div>
      </Container>
    </>;
}
FAQ.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common", "forms", "menu", "faq", "footer", 'swal']))
    }
  };
};